export const channelName = channel_id => {
  switch (channel_id) {
    case 'purchase':
      return 'Cestas'

    case 'whatsapp':
      return 'WhatsApp'

    case 'whatsapp_bot':
      return 'WhatsApp'

    case 'whatsapp_bot_zs':
      return 'WhatsApp'

    case 'magento_ecommerce':
      return 'Ecom'

    case 'vtex_ecommerce':
      return 'Ecom (Vtex)'

    case 'vtex_seasonal':
      return 'Ecom VTEX Seasonal'

    case 'vtex':
      return 'Ecom'

    default:
      return channel_id
  }
}
